<template>
    <QualificationField
        :title="$t('profile.vetting.qualification.professional.interests.title')"
        :field-author-and-date="qualification.professionalInterests"
        data-testid="admin-section-tabs-qualification-interests"
    >
        <VJoyTextarea
            v-if="profileQualificationStore.inEditMode"
            v-model="profileQualificationStore.qualificationUpdateForm.professionalInterests"
            :placeholder="$t('profile.vetting.qualification.professional.interests.placeholder')"
            autogrow
            data-testid="vetting-professional-interests-edition"
        ></VJoyTextarea>
        <TextField
            v-else
            truncate
            :content="profileQualificationStore.qualificationUpdateForm.professionalInterests"
            :replace-by="$t('profile.vetting.qualification.professional.interests.empty.placeholder')"
            data-testid="vetting-professional-interests"
        />
    </QualificationField>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {VJoyTextarea} from '@maltjoy/core-vue';
    import TextField from '~/components/admin-section-tabs/qualification/TextField.vue';
    import {useProfileQualificationStore} from '~/store/profileQualificationStore';
    import QualificationField from './ui/QualificationField.vue';

    const profileQualificationStore = useProfileQualificationStore();

    const {qualification} = storeToRefs(profileQualificationStore);
</script>
